import { CourseInboxReplyResponse, CourseInboxReplyId, CourseInboxId } from '@business/entities/course_inbox';
import { Endpoint } from '@business/api/endpoint';
import { CommonService } from '@business/services';
import { SendMessageFormData } from '@modules/CourseInboxPage/CourseInboxReplyPage/SendMessage';

export function fetchCourseInboxReplies(inboxId: CourseInboxId) {
  return Endpoint.get<CourseInboxReplyResponse[]>(`@makh/course-inbox-reply`, { params: { inboxId } });
}

export function createCourseInboxReply(data: SendMessageFormData) {
  const formData = CommonService.toFormData(data);

  return Endpoint.post<CourseInboxReplyResponse>(`@makh/course-inbox-reply`, { formData, hasFiles: true });
}

export function updateCourseInboxReply(id: CourseInboxReplyId, data: Partial<CourseInboxReplyResponse>) {
  return Endpoint.patch<CourseInboxReplyResponse>(`@makh/course-inbox-reply/${id}`, { data });
}

export function deleteCourseInboxReply(id: CourseInboxReplyId) {
  return Endpoint.delete<void>(`@makh/course-inbox-reply/${id}`);
}

export function fetchCourseInboxReply(id: CourseInboxReplyId) {
  return Endpoint.get<CourseInboxReplyResponse>(`@makh/course-inbox-reply/course-inbox-reply/${id}`);
}
